import { render } from "./Flash.vue.js?vue&type=template&id=74c62029!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Flash.vue?vue&type=template&id=74c62029"
const script = {  }

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__